export default [
  {
    path: '/invitations/ana/confirm',
    name: 'invitations.ana.confirm',
    meta: {
      layout: 'ana-invitation',
    },
    component: () => import('@/views/pages/invitations/ana/Confirm.vue'),
  }
]